import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getHelp } from '#/redux/modules/accedoOne/selectors';
import { requestHelp } from '#/redux/modules/accedoOne/actions';
import { parentZone } from '#/config/strings';
import kidSafe from '#/static/images/icons/sensical_small_kidSafe.svg';
import styles from './HelpModal.scss';

const HelpModal = () => {
  const dispatch = useDispatch();
  const content = useSelector(getHelp);
  const contentAreaRef = useRef(null);

  useEffect(() => {
    if (!content) {
      dispatch(requestHelp);
    }
    contentAreaRef?.current?.focus();
  }, []);

  return (
    <>
      <h2 className={(styles.title, styles.modalTitle)}>{parentZone.help}</h2>
      <div className={styles.kidImg}>
        <img src={kidSafe} alt="Kid Safe" />
      </div>
      <p ref={contentAreaRef} tabIndex={0} className={styles.textContent}>
        {content}
      </p>
    </>
  );
};

export default HelpModal;
